import { getL11nString } from "@/l11n/l11n";
import { useMemo } from "preact/hooks";
import AppStoreBadges from "./AppStoreBadges";

const ContinueInAppInner = ({ headlineKey = "do_more_with_taalia" }) => {
  const strings = useMemo(
    () => ({
      do_more_with_taalia: getL11nString(headlineKey),
      get_app_end_of_report: getL11nString("get_app_end_of_report"),
    }),
    []
  );

  return (
    <div className="flex flex-col items-center text-center">
      <div className="text-4xl font-semibold mb-4 mt-2">
        {strings.do_more_with_taalia}
      </div>
      <div className="text-lg mb-4 max-w-[400px]">{strings.get_app_end_of_report}</div>
      <AppStoreBadges />
    </div>
  );
};

export default ContinueInAppInner;
